module.exports = __webpack_public_path__ + "img/hyzl_bg1.81c2cb9c.png";